import { CalendarAltIcon } from "assets/icons";
import { t } from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import { DateInput, FormField, TimeInput } from "ui";

import { OfferFormValues } from "../../CreateOfferModal.types";

import styles from "../../CreateOfferModal.module.scss";

const PostingDateRange = () => {
  const { control } = useFormContext<OfferFormValues>();

  return (
    <div className={styles["offer__modal--header"]}>
      <p className={styles["offer__modal--header-title"]}>{t("Timeframe")}</p>
      <div className={styles["offer__modal--header-group"]}>
        <Controller
          control={control}
          name={"fromPostingDate"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FormField label="From date" errorMessage={error?.message}>
              <DateInput
                value={value}
                onChange={onChange}
                calendarIcon={<CalendarAltIcon />}
              />
            </FormField>
          )}
        />

        <Controller
          control={control}
          name={"fromPostingTime"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FormField label="From time" errorMessage={error?.message}>
              <TimeInput value={value} onChange={onChange} format="HH:mm" />
            </FormField>
          )}
        />
      </div>

      <div className={styles["offer__modal--header-group"]}>
        <Controller
          control={control}
          name={"toPostingDate"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FormField label="To date" errorMessage={error?.message}>
              <DateInput
                value={value}
                onChange={onChange}
                calendarIcon={<CalendarAltIcon />}
              />
            </FormField>
          )}
        />

        <Controller
          control={control}
          name={"toPostingTime"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <FormField label="To time" errorMessage={error?.message}>
              <TimeInput value={value} onChange={onChange} format="HH:mm" />
            </FormField>
          )}
        />
      </div>
    </div>
  );
};

export default PostingDateRange;
